import { CreateOrUpdateEscrowSettingsApiRow, CreateOrUpdateEscrowSettingsRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCreateEscrowSettings = makeValidator({
  FieldParser: CreateOrUpdateEscrowSettingsRow,
});

export const validateCreateEscrowSettingsApi = makeValidator({
  FieldParser: CreateOrUpdateEscrowSettingsApiRow,
});
